// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"rev-usage-table_btnBlue_2LcNc","btnBlueOutline":"rev-usage-table_btnBlueOutline_2GD0p","invalidCoding":"rev-usage-table_invalidCoding_166Wl"};